import React, { useState, useEffect } from "react";
import { Avatar } from "@material-ui/core";
import { Person, Group } from "@material-ui/icons";
import styles from "./Style.module.css";

function ChatAvatarItem({
  image,
  initials,
  label,
  displayType,
  isGroup,
  size = 38,
  className,
}) {
  const [imgError, setImgError] = useState(false);

  useEffect(() => {
    setImgError(false);
  }, [image]);

  const isValidImg =
    image &&
    typeof image === "string" &&
    image.trim() !== "" &&
    image !== "null" &&
    image !== "undefined" &&
    !imgError;

  const showInitials =
    displayType === "INITIALS" ||
    (!isValidImg && initials && initials.trim() !== "");

  if (showInitials) {
    return (
      <Avatar
        className={className || styles.initialsAvatar}
        style={{
          width: size,
          height: size,
          fontSize: size <= 30 ? "0.72rem" : "0.85rem",
        }}
      >
        {initials?.slice(0, 2)?.toUpperCase()}
      </Avatar>
    );
  }

  if (isValidImg) {
    return (
      <img
        src={image}
        className={className || styles.chatAvatar}
        style={{ width: size, height: size, objectFit: "cover", borderRadius: "50%" }}
        alt={label || "Avatar"}
        onError={() => {
          setImgError(true);
        }}
      />
    );
  }

  // Fallback to label initials or Icon placeholder if label is missing
  const fallbackLabel = (label || "").trim();
  if (fallbackLabel.length > 0) {
    return (
      <Avatar
        className={className || styles.initialsAvatar}
        style={{
          width: size,
          height: size,
          fontSize: size <= 30 ? "0.72rem" : "0.85rem",
        }}
      >
        {fallbackLabel.slice(0, 2).toUpperCase()}
      </Avatar>
    );
  }

  return (
    <Avatar
      className={className || styles.initialsAvatar}
      style={{
        width: size,
        height: size,
        backgroundColor: "#656d76",
      }}
    >
      {isGroup ? (
        <Group style={{ fontSize: size * 0.55 }} />
      ) : (
        <Person style={{ fontSize: size * 0.55 }} />
      )}
    </Avatar>
  );
}

export default ChatAvatarItem;
